import { HigharcPlan } from '@/models/higharc-plan.model';
import { Component, Input } from '@angular/core';
import { Plan } from 'src/app/models/plan.model';

@Component({
    selector: 'app-plan-badge',
    template: `
    <div class="flex">
      <img [src]="getPlanThumb()" class="mr-2 h-[45px] border-round" style="border-radius: var(--border-radius);"/>
      <div class="mr-0 md:mr-1 ml-1">
        <!-- <div class="block text-xl text-500 font-medium mb-1">{{ getPlanName() }}</div> -->
        <div class="block text-600 text-xl text-left font-bold mb-1">{{ getPlanName() }}</div>
        <div class="block text-400 text-left">{{ getStyleName() }}</div>
      </div>
    </div>
  `,
  styles: [
    `
    .card {
      border: 1px solid #e9ecef;
    }
    `
  ]
})
export class PlanBadgeComponent {
  @Input() plan: Plan | HigharcPlan | null = null;

  getPlanThumb(): string {
    if (this.plan) {
      if ('Thumb' in this.plan && typeof this.plan.Thumb === 'string') {
        return this.plan.Thumb || '/images/LexarIcon.png';
      } else if ('ThumbURL' in this.plan && typeof this.plan.ThumbURL === 'string') {
        return this.plan.ThumbURL || '/images/LexarIcon.png';
      }
    }
    return '/images/LexarIcon.png';
  }

  getPlanName(): string {
    if (this.plan) {
      if ('Family' in this.plan && typeof this.plan.Family === 'string') {
        return this.plan.Size + '-' + this.plan.Family || 'No Plan Selected';
      }
      else if ('PlanName' in this.plan && typeof this.plan.PlanName === 'string') {
        return this.plan.PlanName || 'No Plan Selected';
      } else if ('planName' in this.plan && typeof this.plan.planName === 'string') {
        return this.plan.planName || 'No Plan Selected';
      }
    }
    return 'No Plan Selected';
  }

  getStyleName(): string {
    if (this.plan) {
      // Check if it's a Plan (has Styles property)
      if ('Styles' in this.plan) {
        return this.plan.Styles?.StyleName || 'Select a plan to continue';
      } else if ('styleName' in this.plan && typeof this.plan.styleName === 'string') {
      // If it's a HigharcPlan (might have a different structure for style)
      return this.plan.styleName || 'Select a plan to continue';
    }
  }
    return 'Select a plan to continue';
  }
}